export default {
  list: (state) => {
    return state.list;
  },
  listOrderedByName: (state) => {
    let orderedList = state.list;
    return orderedList.sort((a, b) => (a.name > b.name ? 1 : -1));
  },
  filteredList: (state) => {
    return state.filteredList.sort((a, b) => {
      let aCC = 0;
      let bCC = 0;
      if (a.totalContributions != "") {
        aCC = parseFloat(a.totalContributions);
      } else if (a.cCTotal != "") {
        aCC = parseFloat(a.cCTotal);
      } else if (a.supplier_cCTotal != "") {
        aCC = parseFloat(a.supplier_cCTotal);
      }
      if (b.totalContributions != "") {
        bCC = parseFloat(b.totalContributions);
      } else if (b.cCTotal != "") {
        bCC = parseFloat(b.cCTotal);
      } else if (b.supplier_cCTotal != "") {
        bCC = parseFloat(b.supplier_cCTotal);
      }
      return aCC < bCC ? 1 : -1;
    });
  },
  impactBusinessById: (state) => (id) => {
    return state.list.find((impactBusiness) => {
      return impactBusiness.id === id;
    });
  },
  currentProfile: (state) => {
    return state.currentProfile;
  },
  loading: (state) => {
    return state.loading;
  },
  keywords: (state) => {
    return state.keywords;
  },
  approved: (state) => {
    let activeList = state.list.filter((impactBusiness) => {
      return impactBusiness.status === "Approved";
    });
    return activeList;
  },
  forLeads: (state) => {
    let activeList = state.list.filter((impactBusiness) => {
      return impactBusiness.impactInterestedStatus === "Open";
    });
    return activeList;
  },
};
